import { render } from "./MessagesComponent.vue?vue&type=template&id=4a0590f4&scoped=true"
import script from "./MessagesComponent.vue?vue&type=script&lang=js"
export * from "./MessagesComponent.vue?vue&type=script&lang=js"

import "./MessagesComponent.vue?vue&type=style&index=0&id=4a0590f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0590f4"]])

export default __exports__